/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useTranslation } from "react-i18next";
import getSchema from "../../lib/api/getSchema";
import notificationState from "../../states/notificationState";
import { useSetRecoilState } from "recoil";
import PopCrudScreenActionItemLayout from "../screenTypes/layout/PopCrudScreenActionItemLayout";
import AccessControl from "../functional/AccessControl";
import PopDirectShipDetailCreateButton from "../input/PopDirectShipDetailCreateButton";
import UpdateRecordButton from "../input/UpdateRecordButton";
import DeleteRecordButton from "../input/DeleteRecordButton";

function PopDirectShipDetail ( props ) {

    const {
        id,
        table,
        view,
        onLoadDataPop,
        onPopApiInitialized,
        selectMst,
    } = props;

    const { t } = useTranslation ();
    const setNotification = useSetRecoilState(notificationState);

    const [schema, setSchema] = useState();
    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    const [isEmpty, setIsEmpty] = useState();

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema(table);

            if (mounted) {

                setSchema(schema);

            }

        })();

        return () => {

            mounted = false;

        };

    }, []);

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });

    };

    const onSuccess = (msg) => {

        notifySuccess(msg);

    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = (msg) => {

        notifyWarning(msg);

    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const onInitialized = ( grid ) => {

        setGrid(grid);

    };

    const onApiInitialized = ( api ) => {

        setApi(api);

        onPopApiInitialized(api);

    };

    const onLoadData = (data) => {

        let isEmpty = data.length < 1 ? true : false;

        setIsEmpty(isEmpty);

        onLoadDataPop(isEmpty);

    };

    const doHandleBackendErrorMsg = (reason) => {
        // reason.response := { data, status, statusText, headers, config, request }
        // data : user error message
        // status : http status code
        // statusText : http status code text
        const response = reason.response;
        return `${response.data} `;
    
    }

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <PopCrudScreenActionItemLayout>
                    <AccessControl accessTarget={schema && schema.name} accessMethod="POST">
                        <PopDirectShipDetailCreateButton
                            id={id}
                            schema={schema}
                            refresh={api}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            customizeErrorMsgCallback={doHandleBackendErrorMsg}
                            selectMst={selectMst}
                        />
                    </AccessControl>
                    <AccessControl accessTarget={schema && schema.name} accessMethod={schema && (schema.updateWithPatch ? "PATCH" : "PUT")}>
                        <UpdateRecordButton
                            id={id}
                            schema={schema}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl accessTarget={schema && schema.name} accessMethod="DELETE">
                        <DeleteRecordButton
                            id={id}
                            schema={schema}
                            grid={grid}
                            refresh={api}
                            color="secondary"
                            disabled={isEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                        />
                    </AccessControl>
                </PopCrudScreenActionItemLayout>
            </>
        );
    }

    return (

        <BasicCrudScreenType 
            id={id} 
            headerTitle={t("term.popDirectShipDetailLot")}
            table={table}
            view={view}
            noCreate
            noEdit
            noDelete
            noExcel
            onLoadData={onLoadData}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
        />

    );

}

export default PopDirectShipDetail;
